<ion-backdrop *ngIf="backdrop" [tappable]="false"></ion-backdrop>
<div id="loader"></div>